var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root-div",staticClass:"d-lg-none w-100 popup-prestation-slider-mobile mb-2 overflow-hidden"})
}
var staticRenderFns = []

export { render, staticRenderFns }